import { NON_ARRAY_VARIABLES } from '../config/appConfig';

/**
 * Подставляет переменные в шаблон текста
 * @param {string} text - Текст с шаблонами вида {{variableName}} или {{variableName[index]}}
 * @param {Object} variables - Объект с переменными
 * @returns {string} - Текст с подставленными значениями
 */
export const renderTemplate = (text, variables = {}) => {
  if (!text || typeof text !== 'string') {
    return text || '';
  }

  // Обрабатываем шаблоны вида {{variableName[index]}}
  text = text.replace(/\{\{(\w+)\[(\d+)\]\}\}/g, (match, variableName, indexStr) => {
    const index = parseInt(indexStr, 10);
    const variable = variables[variableName];
    
    // Если переменная - массив
    if (Array.isArray(variable) && variable[index] !== undefined && variable[index] !== null) {
      return String(variable[index]);
    }
    
    // Если переменная не массив, но есть значение
    if (!Array.isArray(variable) && variable !== undefined && variable !== null) {
      return String(variable);
    }
    
    return match;
  });

  // Обрабатываем обычные шаблоны вида {{variableName}}
  // Используем currentPhraseIndex для массивов (не viewingPhraseIndex, т.к. это только для просмотра истории)
  return text.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
    // Пропускаем переменные, которые не должны быть массивами
    if (NON_ARRAY_VARIABLES.includes(variableName)) {
      const variable = variables[variableName];
      if (variable !== undefined && variable !== null) {
        return String(variable);
      }
      return match;
    }
    
    const variable = variables[variableName];
    
    // Если переменная - массив, используем currentPhraseIndex
    if (Array.isArray(variable)) {
      const index = variables.currentPhraseIndex !== undefined ? variables.currentPhraseIndex : 0;
      
      if (variable[index] !== undefined && variable[index] !== null) {
        return String(variable[index]);
      }
      return match;
    }
    
    // Если переменная не найдена, возвращаем оригинальный шаблон
    if (variable === undefined || variable === null) {
      return match;
    }
    
    // Преобразуем значение в строку
    return String(variable);
  });
};

